import React, { useEffect, useState } from 'react'
import { FaBirthdayCake } from 'react-icons/fa';
import { fetchAllDataAPI } from '../../utils/api';
import { toast } from 'react-toastify';
import moment from 'moment';
import withAuth from '../../utils/withAuth';
import { BASEEMPURLS } from '../../utils/BaseUrl';

const UpcomingBirthday = () => {
    const [birthday, setBirthday] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        getAllUpcomingBirthday()
    }, []);

    const getAllUpcomingBirthday = () => {
        setIsLoading(true);
        fetchAllDataAPI('hr-all-upcoming-birthday').then((res) => {
            if (res.data.status === 1) {
                setBirthday(res.data.birthday || []);
            } else {
                setBirthday([])
            }
            setIsLoading(false);
        }).catch(() => {
            toast.error("Something went wrong");
            setIsLoading(false);
        });
    }

    const renderSkeleton = () => {
        return Array(5).fill(0).map((_, index) => (
            <div className="upcomingbirthday d-flex justify-between align-items-center border-top border-bottom p-2" key={index}>
                <div className="upcomingbirthdayimgname d-flex">
                    <div className="upcomingbirthdayimg">
                        <div className="skeleton skeleton-avatar"></div>
                    </div>
                    <div className="ms-2 upcomingbirthdayname">
                        <div className="skeleton skeleton-text w-75 mb-2"></div>
                        <div className="skeleton skeleton-text w-50"></div>
                    </div>
                </div>
                <div className="upcomingbirthdaydate">
                    <div className="skeleton skeleton-text w-50"></div>
                </div>
            </div>
        ));
    }

    const renderNoDataFound = () => {
        return (
            <div className="text-center py-4">
                <p className="text-secondary mb-0">🎂 No Upcoming Birthdays Found!</p>
            </div>
        );
    }

    return (
        <div className="card radius-10 overflow-hidden w-100 topsection">
            <div className="d-flex align-items-center upcomingtitle">
                <div>
                    <h5 className="mb-0">Upcoming Birthday</h5>
                </div>
                <div className="birthdayicons">
                    <FaBirthdayCake />
                </div>
            </div>

            <div className="p-2 ps ps--active-y bodysection">
                {isLoading ? (
                    renderSkeleton()
                ) : (
                    birthday.length > 0 ? (
                        birthday.map((birthdayItem, index) => (
                            <div className="upcomingbirthday d-flex justify-between align-items-center border-top border-bottom p-2" key={index}>
                                <div className="upcomingbirthdayimgname d-flex">
                                    <div className="upcomingbirthdayimg">
                                        <img src={BASEEMPURLS(birthdayItem?.emp_foto)} className="rounded-circle" alt="avatar" />
                                    </div>
                                    <div className="ms-2 upcomingbirthdayname">
                                        <h6 className="mb-1 font-14">{birthdayItem.emp_name}</h6>
                                        <p className="mb-0 font-5 text-secondary">{birthdayItem.emp_job_role}</p>
                                    </div>
                                </div>
                                <div className="upcomingbirthdaydate">
                                    <span>{moment(birthdayItem?.emp_dob).format('Do MMM YYYY')}</span>
                                </div>
                            </div>
                        ))
                    ) : (
                        renderNoDataFound()
                    )
                )}
            </div>

            {/* Skeleton Style */}
            <style jsx="true">{`
                .skeleton {
                    background-color: #e2e2e2;
                    border-radius: 4px;
                    animation: shimmer 1.5s infinite linear;
                }
                .skeleton-avatar {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                }
                .skeleton-text {
                    height: 12px;
                    margin-bottom: 8px;
                    border-radius: 4px;
                }
                @keyframes shimmer {
                    0% { background-position: -400px 0; }
                    100% { background-position: 400px 0; }
                }
            `}</style>
        </div>
    )
}

export default withAuth(UpcomingBirthday)
